import { useNavigate } from "react-router-dom";
import type { subscriptionCards as subCards, billingCards as billCards } from "@/mocks/help-center";

type CardItem = (typeof subCards)[number] | (typeof billCards)[number];

interface TopicSectionProps {
  title: string;
  description: string;
  cards: CardItem[];
}

export default function TopicSection({
  title,
  description,
  cards,
}: TopicSectionProps) {
  const navigate = useNavigate();

  return (
    <section>
      <div className="mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-3 tracking-tight font-heading">
          {title}
        </h2>
        <div className="w-12 h-1 bg-accent mb-4 rounded-full" />
        <p className="text-base md:text-lg text-gray-500 max-w-2xl">
          {description}
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {cards.map((card) => (
          <button
            key={card.id}
            className="bg-white p-6 md:p-8 flex flex-col text-left transition-all duration-300 hover:-translate-y-1 rounded-2xl shadow-[0_2px_8px_rgba(15,64,143,0.05)] hover:shadow-[0_12px_32px_rgba(15,64,143,0.10)] border border-cream-dark/40"
            onClick={() => navigate(card.path)}
          >
            <div className="mb-4">
              <div className="w-12 h-12 bg-ice rounded-xl flex items-center justify-center mb-4">
                <i className={`${card.icon} text-primary text-xl`} />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-primary mb-2 font-heading">
                {card.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                {card.description}
              </p>
            </div>
            <div className="mt-auto">
              <i className="ri-arrow-right-line text-primary text-lg" />
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}